import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const SurveyPoint = ({ style, number, className }) => {
  return (
    <div
      className={`absolute rounded-full font-semibold text-xs w-6 h-6 flex justify-center items-center ${className}`}
      style={style}
    >
      {number}
    </div>
  );
};

export default SurveyPoint;
